import React, { memo, Suspense } from "react";
import StudentDetailsLayout from "../../../components/StudentDetailsLayout";
import { useSchoolTemplates } from "../hooks";
import TemplateSwitcher from "./TemplateSwitcher";
import classes from "./StudentTranscriptPreview.scss";
import PreviewSkeleton from "./PreviewSkeleton";
import { useBackgroundQuery } from "@apollo/client";
import {
  getOrgGradeScalesQuery,
  getStudentTranscriptDataQuery,
} from "../modules/queries";
import _ from "lodash";
import DownloadButton from "./DownloadButton";
import { getOrganizationId } from "modules/CommonSelectors";
import { useUnsavedChanges } from "TranscriptsV3/hooks";

const StudentTranscriptPreviewContainer = React.lazy(() =>
  import("./StudentTranscriptPreviewContainer")
);

const StudentTranscriptPreview = ({
  params: { schoolId: paramsSchoolId, studentId },
  currentStudent,
  previousStudentId,
  nextStudentId,
  onStudentClick,
  router,
  route,
}) => {
  useUnsavedChanges(false, router, route);

  const studentName = _.get(currentStudent, "name", "") || "";
  const schoolId =
    _.get(currentStudent, "yearGroup.grade.curriculumProgram.id", "") ||
    paramsSchoolId;
  const {
    isLoading,
    templates,
    setTemplateId,
    selectedTemplate,
    accountTemplatesCount,
  } = useSchoolTemplates(schoolId);

  const [queryRef] = useBackgroundQuery(getStudentTranscriptDataQuery, {
    variables: { id: studentId },
    fetchPolicy: "cache-and-network",
  });

  const [gradeScalesQueryRef] = useBackgroundQuery(getOrgGradeScalesQuery, {
    variables: { id: getOrganizationId() },
    fetchPolicy: "cache-and-network",
  });

  const showLoader = isLoading || !schoolId;

  return (
    <StudentDetailsLayout
      childrenClass={classes.childrenClass}
      headerRightComponent={
        <div className={classes.headerRightComponent}>
          <TemplateSwitcher
            isLoading={showLoader}
            templates={templates}
            selectedTemplate={selectedTemplate}
            setTemplateId={setTemplateId}
          />
          <DownloadButton
            studentId={studentId}
            schoolId={schoolId}
            isLoading={showLoader}
            templates={templates}
            selectedTemplate={selectedTemplate}
            studentName={studentName}
          />
        </div>
      }
      currentStudent={currentStudent}
      previousStudentId={previousStudentId}
      nextStudentId={nextStudentId}
      onStudentClick={onStudentClick}
    >
      <Suspense fallback={<PreviewSkeleton />}>
        <StudentTranscriptPreviewContainer
          queryRef={queryRef}
          gradeScalesQueryRef={gradeScalesQueryRef}
          body={_.get(selectedTemplate, "body")}
          isLoading={showLoader}
          accountTemplatesCount={accountTemplatesCount}
        />
      </Suspense>
    </StudentDetailsLayout>
  );
};

export default memo(StudentTranscriptPreview);
